






































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { dictServe, doublePrevention } from '@/api/installServer';
import publishObjectPath from '@/util/configRegistry';

@Component
export default class PublicProp extends Vue {
  visible = false;
  canEdit = false;
  title = '';
  formData: any = {
    annex: [], // 附件
    // assess: '', // 演练评估
    executionSituation: '', // 执行情况（待执行、已执行、未执行）
    drillPlace: '', // 演练地点
    name: '', // 演练名称
    staffNum: '', // 演练人数
    startDate: '', // 演练开始日期
    endDate: '', // 演练结束日期
    way: '', // 演练方式
    // summary: '', // 演练总结
    orgUnit: '', //组织单位
    emergencyPlanId: '', //预案名称 id
    planName: '', //预案名称
    drillType: '', //演练类型
    drillTypeCode: '', //演练类型
    drillContent: '', //演练内容
    frequencyOfDevelopment: '', //演练内容
    drillHierarchy: '', //演练层级
    drillHierarchyCode: '', //演练层级
    remarks: '', //备注
  };
  wayList: any = []; // 演练方式
  ruleForm: any = {
    name: [
      { required: true, message: '请输入活动名称', trigger: 'blur' },
      { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' },
    ],
    drillPlace: [{ required: true, message: '请输入演练地点', trigger: 'blur' }],
    way: [{ required: true, message: '请选择演练方式', trigger: 'blur' }],
    staffNum: [{ required: true, message: '请输入演练人数', trigger: 'blur' }],
    executionSituation: [{ required: true, message: '请选择执行情况', trigger: 'blur' }],
    startDate: [{ required: true, message: '请选择演练开始时间', trigger: 'blur' }],
    endDate: [{ required: true, message: '请选择演练结束时间', trigger: 'blur' }],
  };

  executionSituationList: any = [{ label: '待执行' }, { label: '已执行' }, { label: '未执行' }];

  private planList: any = [];
  planChange(e: any) {
    if (e) {
      this.formData.planName = this.planList.find((item: any) => item.id === e).name;
    } else {
      this.formData.planName = '';
    }
  }

  private drillHierarchyOption: any = [];
  private drillHierarchyChange(e: any) {
    if (e) {
      const findData: any = this.drillHierarchyOption.find((item: any) => item.value === e);
      this.formData.drillHierarchy = findData.label;
    } else {
      this.formData.drillHierarchy = '';
    }
  }

  private drillTypeOption: any = [];
  private drillTypeChange(e: any) {
    if (e) {
      const findData: any = this.drillTypeOption.find((item: any) => item.value === e);
      this.formData.drillType = findData.label;
    } else {
      this.formData.drillType = '';
    }
  }

  showDialog(data: any) {
    if (data.type !== 'detail') {
      this.getDetailsMapByName('emergencyDrillWay'); // 获取演练方式的下拉
      this.getDetailsMapByName('drillType'); // 获取演练方式的下拉
      this.getDetailsMapByName('drillHierarchy'); // 获取演练方式的下拉
      this.getPlanList(); // 获取预案列表
    }

    switch (data.type) {
      case 'add':
        this.title = '添加演练计划';
        this.canEdit = false;
        break;
      case 'detail':
        this.title = '演练计划详情';
        this.canEdit = true;
        this.getDetail(data.data.id);
        break;
      case 'edit':
        this.title = '编辑演练计划';
        this.canEdit = false;
        this.getDetail(data.data.id);
        break;
      default:
        this.title = '';
    }
    this.visible = true;
  }

  getPlanList() {
    doublePrevention.getEmergencyDrillPlanAll({}).then((res: any) => {
      if (res.code === '200') {
        this.planList = res.data;
      }
    });
  }

  /* 演练方式 的下拉 */
  getDetailsMapByName(name: any) {
    dictServe.getDetailsMapByName(name).then((res: any) => {
      if (res.code === '200') {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            value: key,
            label: res.data[key],
          });
        }
        if (name === 'emergencyDrillWay') {
          this.wayList = helpArr;
        } else if (name === 'drillType') {
          this.drillTypeOption = helpArr;
        } else if (name === 'drillHierarchy') {
          this.drillHierarchyOption = helpArr;
        }
      } else {
        this.$message.warning('获取应急队伍类型下拉数据失败！');
      }
    });
  }

  hideDialog() {
    this.visible = false;
    this.formData = {};
    this.fileList = [];
    this.formData.annex = [];
    this.$emit('getTableData');
    (this.$refs.form as any).resetFields();
  }

  submitForm() {
    (this.$refs.form as any).validate((valid: any) => {
      if (valid) {
        if (this.title === '添加演练计划') this.addEmergencyDrillRecord();
        if (this.title === '编辑演练计划') this.editEmergencyDrillRecord();
      } else {
        return false;
      }
    });
  }

  /* 新增的接口 */
  addEmergencyDrillRecord() {
    doublePrevention
      .addEmergencyDrillPlan({
        ...this.formData,
        annex: this.formData.annex ? this.formData.annex.toString() : '',
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('成功新增一条数据！');
          this.hideDialog();
        } else {
          this.$message.warning('网络错误，请稍后再试！');
        }
      });
  }

  /* 编辑的接口 */
  editEmergencyDrillRecord() {
    doublePrevention
      .editEmergencyDrillPlan({
        ...this.formData,
        annex: this.formData.annex ? this.formData.annex.toString() : '',
        startDate: this.formData.startDate ? this.formData.startDate : null,
        endDate: this.formData.endDate ? this.formData.endDate : null,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('成功新增一条数据！');
          this.hideDialog();
        } else {
          this.$message.warning('网络错误，请稍后再试！');
        }
      });
  }

  /* 详情的接口 */
  getDetail(id: any) {
    doublePrevention.getSingleEmergencyDrillPland(id).then((res: any) => {
      if (res.code === '200') {
        this.formData = res.data;
        this.fileList = res.data.annexList;
      } else {
        this.$message.warning('获取数据失败！');
      }
    });
  }

  /* 导入用到的 */
  private uploadUrl: any = publishObjectPath.serverUrl + '/api/sysManage/sysFile/annex';
  private headers: any = {};
  private fileList: any = [];
  private handleRemove(file: any, fileList: any) {
    this.fileList = fileList;
    const helpArr: any = [];
    this.fileList.forEach((item: any) => {
      if (item.response) {
        helpArr.push(item.response.data[0].id);
      } else {
        helpArr.push(item.id);
      }
    });
    this.formData.annex = helpArr;
  }

  private handleExceed(files: any, fileList: any) {
    this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
  }

  private beforeAvatarUpload(files: any, fileList: any) {
    // 限制上传文件类型
    const suffix = files.name.substring(files.name.lastIndexOf('.') + 1);
    // console.log(suffix);
    if (suffix === 'PNG' || suffix === 'JPG' || suffix === 'JPEG' || suffix === 'BMP' || suffix === 'GIF' || suffix === 'SVG' || suffix === 'PDF' || suffix === 'TXT' || suffix === 'DOC' || suffix === 'DOCX' || suffix === 'XLSX' || suffix === 'XLS' || suffix === 'png' || suffix === 'jpg' || suffix === 'jpeg' || suffix === 'bmp' || suffix === 'gif' || suffix === 'svg' || suffix === 'pdf' || suffix === 'txt' || suffix === 'doc' || suffix === 'docx' || suffix === 'xlsx' || suffix === 'xls') {
      return true;
    } else {
      this.$message.warning('上传格式不正确，请上传格式为：PNG,JPG,JPEG,BMP,GIF,SVG,PDF,TXT,DOC,DOCX,XLSX,XLS！');
      return false;
    }
  }

  private handleAvatarCardFrontSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.annex = arr;
  }
}
